const notificationEllipse = (text = '') => {
  if (text?.length > 35) {
    text = `${text?.substring(0, 35)} ...`;
  } else if (text?.length === 0) {
    text = 'N/A';
  }
  return text;
};
export default notificationEllipse;
